<template>
   <vue-final-modal
      v-model="v310Modal" 
      classes="modal-container"
      content-class="v310-modal-content"
      :drag="true"
      drag-selector=".drug-area"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
      <div class="drug-area">
         <button 
            id="first_hv"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="tabIndexNumber(2)" 
            @click="$emit('cancel')"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
               <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
         </button>
         <span class="modal__title tx-cl-white">Historial de Afiliado</span>
      </div>
      <div class="up-voucher p-0 mt-1 border-top border-2">
         <div class="container-fluid m-0 p-0">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last_hv').focus()"></div>

            <table class="table table-sm table-primary table-striped table-borderless">
               <thead class="table-dark text-center">
                  <tr class="bg-thead">
                     <td class="border-end">Autorización</td>
                     <td colspan="2" class="border-end">Afiliado</td>
                     <td colspan="2">Vigencia</td>
                  </tr>
               </thead>
               <tbody id="tbid">
                  <tr v-for="(item, index) in history" :key="index" 
                        class="border-0 hover-tr" 
                        @click="showOnlyData(index)"
                        >
                     <td class="border-end">{{item.id}}</td>
                     <td>{{item.cuil}}</td>
                     <td class="text-nowrap border-end">{{item.name}}</td>
                     <td>{{item.prescriptionDate}}</td>
                     <td class="border-end">{{item.validDate}}</td>
                  </tr>
               </tbody>
            </table>
            <!--
               @click="showV310( 'D', index )"
            <pre>{{ history }}</pre>
            -->
         </div>
      </div>

      <div class="row p-0 justify-content-between mx-1 border-top border-2 mt-1">
         <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
         <div class="d-flex justify-content-end pt-2 px-0 col-10">
            <button type="button" 
                  id="last_hv"
                  :tabindex="tabIndexNumber(3)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="$emit('cancel')"
                  >
               Salir
            </button>
            <div :tabindex="tabIndexNumber(4)" onfocus="document.getElementById('first_hv').focus()"></div>
         </div>
      </div>
      <!--
      {{ v310Rest }}
      {{ v310Object }}
      -->
   </vue-final-modal>

   <data-v-310
      v-if="dataV310" 
      :v310Object="v310Object"
      :v310Rest="v310Rest"
      :annulCompl="true"
      @cancel="dataV310 = false"
      @annulComplObj="(val) => annulComplObj(val)"
      />
      
   </template>
<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex'   

import WspService from '../../workSpace/workSpace.service';
import V310Service from '../voucher310.service';
//import AnalyService from '../../analytics/analytics.service';

import UserCircle from '../../../components/UserCircle.vue';
import DataV310 from './DataV310.vue';
//import AffiliateData from '../../analytics/components/affiliate/AffiliateDataShow.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      DataV310
   },

   props: {
      history: Array
   },

   emits: [ 'cancel', 'annulComplObj' ],

   setup( props, { emit } ) {

      const initialTabIndex = ref(100)
      const v310Modal = ref(true)
      const myCircle = ref({})
      const store = useStore()
      //
      const dataV310 = ref(false)
      const v310Object = ref({})
      const v310Rest = ref({})
      
      //const dataAffil = ref({})
      //const testtxt = ref('Dato Prueba')
      
      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function annulComplObj( val ) {
         console.log(val)
         emit( 'annulComplObj', val )
         nextTick(() => {
            emit( 'cancel' )
         })
      }

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
         /*

         AnalyService.getAffiliateBasicData( props.v310Object.cuil )
         .then(response => {
            dataAffil.value = response.data 
         })
         .catch(error => {
            console.log(error)
         })
         */
      }

      function showOnlyData( index ) {
         v310Object.value = props.history[ index ]
         V310Service.getVoucherRestData( Number(props.history[ index ].id ) )
         .then(response => {
            v310Rest.value = response.data
            console.log(response.data)
            nextTick(() => {
               dataV310.value = true
            })
         })
         .catch(error => {
            console.log(error);
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         annulComplObj,
         dataV310,
         myCircle,
         opened,
         showOnlyData,
         tabIndexNumber,
         v310Modal, v310Object, v310Rest
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.v310-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.up-voucher {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.bg-contrast {
   background-color: #d2cece;
}
.border-contrast {
   border: 1px solid #d2cece;
}
.tr-drugs {
   font-size: 0.875rem;
}
td {
   height: 1.5rem;   
}
.pill {
   height: 1.5rem;   
}
.hover-tr:hover {
   cursor: pointer;
   opacity: .75;
}
</style>
